import {
    PlayCircleIcon,
    GlobeAltIcon,
    DocumentTextIcon,
    FilmIcon,
    CpuChipIcon,
    SparklesIcon,
    HeartIcon,
    BoltIcon,
    KeyIcon
} from '@heroicons/react/24/solid';

// --- Definición de Categorías (con colores personalizados) ---
export const ToolCategories = {
    BeliefExercises: {
        id: 'BELIEF_EXERCISES',
        title: 'Belief Exercises',
        Icon: KeyIcon,
        iconColor: 'text-yellow-400', // Color personalizado para la categoría
    },
    HealingExercises: {
        id: 'HEALING_EXERCISES',
        title: 'Healing Exercises',
        Icon: HeartIcon,
        iconColor: 'text-red-400', // Color personalizado para la categoría
    },
    MindRewire: {
        id: 'MIND_REWIRE',
        title: 'Rewire Your Mind',
        Icon: CpuChipIcon,
        iconColor: 'text-green-400', // Color personalizado para la categoría
    },
    RiseFrequency: {
        id: 'RISE_FREQUENCY',
        title: 'Rise Your Frequency',
        Icon: SparklesIcon,
        iconColor: 'text-violet-400', // Color personalizado para la categoría
    },
};

// --- Lista de Herramientas (con el objeto categoría completo) ---
export const basharToolsData = [
    {
        type: 'audio',
        category: ToolCategories.MindRewire,
        title: "The Money Workshop",
        id: 'money-workshop-material',
        description: "A guided audio session exploring the relationship between money and personal empowerment.",
        audioUrl: "https://gusaguiar.com/assets/bashar/money/Bashar - The Money Workshop Audio.MP3",
        Icon: PlayCircleIcon,
        iconColor: "text-green-400",
        host: 'bashar',
    },
    {
        type: 'youtube',
        category: ToolCategories.BeliefExercises,
        title: "The Threshold of Believability",
        id: 'threshold-of-believability',
        description: "Learn how to find the edge of your belief system to make gradual, lasting changes without resistance.",
        youtubeId: "LnY3JUmVRSI",
        Icon: SparklesIcon,
        iconColor: "text-purple-400",
        host: 'bashar',
    },
    {
        type: 'youtube',
        category: ToolCategories.HealingExercises,
        title: "The Infinity Symbol Brain-Balancing",
        id: 'infinity-symbol-brain-balancing',
        description: "An exercise to balance the left and right hemispheres of the brain, creating neurological coherence and enhancing intuition.",
        youtubeId: "x7LVvdxNNaY",
        Icon: BoltIcon,
        iconColor: "text-yellow-400",
        host: 'bashar',
    },
    {
        type: 'internal',
        category: ToolCategories.MindRewire,
        title: "15 Minutes and Counting",
        id: '15-min-count-part-1',
        description: "A step-by-step guided exercise to help you reprogram limiting beliefs and align with your highest excitement.",
        pathUrl: "/bashar/tools/15-min-count/1",
        Icon: DocumentTextIcon,
        iconColor: "text-green-400",
        host: 'bashar',
    },
    {
        type: 'internal',
        category: ToolCategories.MindRewire,
        title: "15 Minutes and Counting - Part 2",
        id: '15-min-count-part-2',
        description: "Continuation of the 15 Minutes and Counting exercise, focusing on deepening your connection to your core excitement.",
        pathUrl: "/bashar/tools/15-min-count/2",
        Icon: DocumentTextIcon,
        iconColor: "text-green-400",
        host: 'bashar',
    },
    {
        type: 'internal',
        category: ToolCategories.MindRewire,
        title: "15 Minutes and Counting - Part 3",
        id: '15-min-count-part-3',
        description: "Final part of the 15 Minutes and Counting exercise, helping you solidify your new beliefs and take inspired action.",
        pathUrl: "/bashar/tools/15-min-count/3",
        Icon: DocumentTextIcon,
        iconColor: "text-green-400",
        host: 'bashar',
    },
    {
        type: 'youtube',
        category: ToolCategories.RiseFrequency,
        title: "Going Gamma",
        id: 'going-gamma',
        description: "Breathing exercise to elevate your brainwave state to gamma, associated with heightened perception and consciousness.",
        youtubeId: "gOgRZc0Gv80",
        Icon: PlayCircleIcon,
        iconColor: "text-blue-400",
        host: 'bashar',
    },
    {
        type: 'video',
        category: ToolCategories.RiseFrequency,
        title: "Gamma Measurements",
        id: 'gamma-measurements',
        description: "A video demonstrating the effects of the Going Gamma exercise on brainwave activity, showcasing real-time measurements.",
        videoUrl: "https://gusaguiar.com/assets/joe/gamma/Joe%20-%20Gamma%20-%20Intro.mp4",
        videoPoster: "https://gusaguiar.com/assets/joe/gamma/Joe%20-%20Gamma.png",
        Icon: PlayCircleIcon,
        iconColor: "text-blue-400",
        host: 'joe',
    },  
];